import { render } from "./address-autocomplete.vue?vue&type=template&id=59e13659&scoped=true"
import script from "./address-autocomplete.vue?vue&type=script&lang=js"
export * from "./address-autocomplete.vue?vue&type=script&lang=js"

import "./address-autocomplete.vue?vue&type=style&index=0&id=59e13659&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e13659"]])

export default __exports__